(() => {
  const root = document.querySelector('[data-jc-db-hero]');
  const trustTemplate = document.querySelector('[data-jc-db-hero-trust-template]');

  if (!root || !trustTemplate) return;

  function preserveTrustRow() {
    if (root.querySelector('.jc-db-hero-trust')) return;

    const copy = root.querySelector('[data-rid="4044220a-6ba9-42b7-a683-32b69e56da28"]');
    if (copy) copy.append(trustTemplate.content.cloneNode(true));
  }

  preserveTrustRow();

  const observer = new MutationObserver(preserveTrustRow);
  observer.observe(root, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
